import { PublicEventLocale, ScheduleItemV2 } from '@hopin-team/api-hopin';
import { TFunction } from '@hopin-team/provider-translation';
import { IconProp } from '@hopin-team/ui-icon';
import React from 'react';

import { getEventPartLabel, truncateString } from '../../helpers';
import { EventPartIcon } from '../Icons';
import { GenericTag } from './GenericTag';

export const eventPartIcons: Record<
  string,
  { textColor: string; backgroundColor: string; icon?: IconProp }
> = {
  networking: {
    textColor: 'COLOR.PURPLE.500',
    backgroundColor: 'COLOR.PURPLE.100',
    icon: 'handshake',
  },
  people: {
    textColor: 'COLOR.RED.500',
    backgroundColor: 'COLOR.RED.100',
    icon: 'people',
  },
  stage: {
    textColor: 'COLOR.BLUE.500',
    backgroundColor: 'COLOR.BLUE.100',
    icon: 'camera',
  },
  expo: {
    textColor: 'COLOR.YELLOW.500',
    backgroundColor: 'COLOR.YELLOW.100',
    icon: 'booth',
  },
  sessions: {
    textColor: 'COLOR.GREEN.500',
    backgroundColor: 'COLOR.GREEN.100',
    icon: 'sessions',
  },
  replay: {
    textColor: 'COLOR.ORANGE.500',
    backgroundColor: 'COLOR.ORANGE.100',
    icon: 'arrow-forward-circle',
  },
  external_url: {
    textColor: 'COLOR.GREY.700',
    backgroundColor: 'COLOR.GREY.100',
    icon: 'open-in-new',
  },
  break: {
    textColor: 'COLOR.GREY.700',
    backgroundColor: 'COLOR.GREY.100',
    icon: 'break',
  },
  custom: {
    textColor: 'COLOR.GREY.700',
    backgroundColor: 'COLOR.GREY.100',
  },
  app: {
    textColor: 'COLOR.GREY.700',
    backgroundColor: 'COLOR.GREY.100',
    icon: 'grid-view',
  },
};

export const EventPartTag = ({
  t,
  eventPart,
  eventLocale,
  indicator,
  indicatorTooltip = '',
  testId,
  customEventPartIcon,
  customEventPartTitle,
  appTitle,
}: {
  t: TFunction;
  eventPart: ScheduleItemV2['event_part_type'];
  eventLocale?: PublicEventLocale;
  indicator?: number;
  indicatorTooltip?: string;
  testId?: string;
  customEventPartIcon?: string;
  customEventPartTitle?: string;
  appTitle?: string;
}) => {
  const styling = eventPartIcons[eventPart];
  const eventPartLabel = getEventPartLabel({
    t,
    eventPart,
    eventLocale,
    customEventPartTitle,
    appTitle,
  });

  return (
    <GenericTag
      icon={
        <EventPartIcon
          eventPartType={eventPart}
          customEventPartIcon={customEventPartIcon}
          eventPartLabel={eventPartLabel}
        />
      }
      label={
        eventPart === 'custom'
          ? truncateString(eventPartLabel, 12, '...')
          : eventPartLabel || ''
      }
      testId={testId}
      styling={styling}
      indicator={indicator}
      indicatorTooltip={indicatorTooltip}
    />
  );
};
